import { useNavigate } from 'react-router-dom';
import { ArrowRight, HelpCircle } from 'lucide-react';

const INDIA_MAP_BG = 'https://images.unsplash.com/photo-1546833998-07256bcc76ad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxJbmRpYSUyMG1hcCUyMGNvbG9yZnVsJTIwaWxsdXN0cmF0aW9ufGVufDB8fHx8MTc3NzA0NDIxMXww&ixlib=rb-4.1.0&q=85';

export default function WhoAmIHomePage() {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center p-6"
      style={{
        backgroundImage: `url(${INDIA_MAP_BG})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
      }}
    >
      <div className="glass-panel p-8 sm:p-10 max-w-md w-full text-center">
        <div className="w-20 h-20 rounded-full bg-amber-400 flex items-center justify-center mx-auto mb-4 shadow-lg border-4 border-white">
          <HelpCircle className="w-10 h-10 text-white" strokeWidth={3} />
        </div>

        <h1 className="font-heading text-4xl sm:text-5xl font-black text-amber-950 mb-2">
          Who Am I?
        </h1>
        <p className="font-body text-base text-amber-800 mb-6 leading-relaxed">
          Birds and animals of India. I will give you clues — can you guess who I am?
        </p>

        <div className="flex justify-center gap-3 mb-6">
          <span className="bg-amber-100 text-amber-800 text-xs font-bold px-3 py-1.5 rounded-full">
            10 Rounds
          </span>
          <span className="bg-amber-100 text-amber-800 text-xs font-bold px-3 py-1.5 rounded-full">
            4 Clues Each
          </span>
          <span className="bg-amber-100 text-amber-800 text-xs font-bold px-3 py-1.5 rounded-full">
            Earn Stars
          </span>
        </div>

        <button
          data-testid="start-who-am-i"
          onClick={() => navigate('/who-am-i/play')}
          className="bg-orange-500 text-white font-black text-xl py-4 px-10 rounded-full border-b-[6px] border-orange-700 active:border-b-0 active:translate-y-[6px] transition-all hover:bg-orange-400 flex items-center gap-3 mx-auto shadow-lg"
        >
          Start Game
          <ArrowRight className="w-6 h-6" />
        </button>

        <button
          data-testid="wai-back-studio"
          onClick={() => navigate('/')}
          className="mt-5 text-amber-800 font-bold text-sm hover:text-amber-950 transition-colors underline"
        >
          Back to Studio
        </button>
      </div>
    </div>
  );
}
